var agi = agi || {};
agi.expressions = agi.expressions || {};

(function () {
    "use strict";
    var exp = function exp() {};

    exp.init = function init(env) {
        exp.env = env;
        exp.container = document.getElementById(env.expressionContainer);

        exp.sorryMessage = document.createElement("div");
        exp.sorryMessage.id = "agi-expressions-sorry-message";
        exp.sorryMessageText = document.createElement("div");
        exp.sorryMessageText.id = "agi-expressions-sorry-message-text";
        exp.sorryMessageText.innerHTML = SORRY_HTML;
        exp.sorryMessage.appendChild(exp.sorryMessageText);
        exp.container.appendChild(exp.sorryMessage);
    };

    /*
    * zpaladino - NOTE: I want this gone after we do feature detection.
    *                   This is a cleaned up version of http://goo.gl/AVoML5
    */
    exp.getCurrentBrowser = function getCurrentBrowser() {
        var userAgent = navigator.userAgent;
        var match = userAgent.match(/(opera|chrome|safari|android|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        var browserName = match[1] || undefined;
        var browserVersion = match[2] || undefined;

        //Get correct IE 11 version
        if(/trident/i.test(browserName)){
            var rvVersion = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
            return 'Internet Explorer ' + (rvVersion[1] || '');
        }

        //Check to see if we actually have Opera and not Chrome
        if(browserName === 'Chrome'){
            var whichVersion = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
            if(whichVersion !== null){
                return whichVersion.slice(1).join(' ').replace('OPR', 'Opera');
            }
        }

        if (browserName !== undefined) {
            match = [browserName,browserVersion];
        }
        else {
            match = [navigator.appName, navigator.appVersion, '-?']
        }

        //Replace version with correct app version if there.
        var version = userAgent.match(/version\/(\d+)/i);
        if(version !== null) {
             match.splice(1, 1, version[1]);
        }

        var browser = match.join(' ');
        browser = browser.replace("MSIE", "Internet Explorer");

        return browser;
    };

    exp.upsellBrowser = function upsellBrowser(browser) {
        var browserMap = {
                            "IE": "Internet Explorer 11",
                            "Safari": "Safari",
                            "Android": "Mobile Chrome",
                            "Firefox": "Firefox 35+",
                            "Chrome": "Chrome 40+"
                         };

        if (browser.indexOf("Explorer") > 0) {
            return browserMap["IE"];
        }

        var browserName = browser.split(" ");
        return browserMap[browserName];
    };

    var currentBrowser = exp.getCurrentBrowser();
    var browserUpsell = exp.upsellBrowser(currentBrowser);
    var SORRY_HTML = "<p>oops! sorry...</p>" +
                     "<p>The card you are trying to view is not supported by your current browser," +
                     " " + currentBrowser + ".  Please <a href='http://browsehappy.com/'" +
                     "target='_blank'>click here</a> to upgrade your browser to " + browserUpsell + " or switch browsers " +
                     "(Firefox or Chrome) so that you can view the ecard properly.</p>" +
                     "<p>Thanks!</p>";

    agi.expressions.ExpressionSorry = exp;
}());
